import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import GiveawayDetailLayer from "../../components/Giveaways/GiveawayDetailLayer";

const GiveawayDetailPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Giveaway" title2="Giveaways" link2="/giveaways" />
      <GiveawayDetailLayer />
    </MasterLayout>
  );
};

export default GiveawayDetailPage;
